import React from 'react'
import CopySite from '../components/CopySite'

export default function Index() {
  return <CopySite path='/' />
}
